// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MentoringPage_mentoring__container__zwyfd {
  background: var(--color-surface-light);
}
.MentoringPage_mentoring__controls__yDCfN {
  display: flex;
  align-items: center;
  gap: var(--gutter);
  flex-wrap: wrap;
  position: sticky;
  top: var(--nav-height);
  background: var(--color-surface-light);
  border-bottom: 1px solid var(--color-border);
  padding: 0 var(--gutter);
  z-index: 2;
}

.MentoringPage_content-container__1gu9K {
  margin-top: var(--gutter);
  padding: var(--gutter);
}

.MentoringPage_pairing-group__MruTd {
  margin-bottom: 2rem;
}
.MentoringPage_pairing-group__title__QY5Fo {
  font-size: var(--font-size-larger);
  font-weight: 600;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
}
.MentoringPage_pairing-group__member__8jUPk {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.MentoringPage_pairing-group__avatar__dzuw0 {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}

.MentoringPage_pairing-skill-group__vwpXh {
  margin-bottom: 1.5rem;
}
.MentoringPage_pairing-skill-group__title__DcItv {
  font-size: var(--font-size-larger);
  font-weight: 500;
  margin-bottom: 0.75rem;
  color: var(--color-text-subtle);
}

.MentoringPage_no-pairings__NZOzQ {
  text-align: center;
  padding: 2rem;
  color: var(--color-text-subtle);
  font-style: italic;
}

/* Mentorship Pairings Section */
.MentoringPage_pairings-list__1JiIh {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 1.25rem;
}

.MentoringPage_pairing-item__yraG8 {
  display: flex;
  flex-direction: column;
  gap: var(--gutter);
  background: var(--color-surface-light);
  border-radius: var(--radius-default);
  padding: var(--gutter);
  border: 1px solid var(--color-border);
}
.MentoringPage_pairing-item__skill__\\+koU0 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.MentoringPage_pairing-item__skill-title__LyL4d {
  font-weight: 600;
  font-size: var(--font-size-larger);
}
.MentoringPage_pairing-item__members__JmPQq {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: calc(var(--gutter) / 2);
}
.MentoringPage_pairing-item__focus__nU5Uz, .MentoringPage_pairing-item__expert__R-BZC {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: calc(var(--gutter) / 8);
}
.MentoringPage_pairing-item__label__Kee\\+h {
  font-size: var(--font-size-smaller);
  color: var(--color-text-subtle);
  margin-bottom: 0.25rem;
}
.MentoringPage_pairing-item__arrow__twsSr {
  color: var(--color-text-subtle);
  padding: 0 calc(var(--gutter) / 2);
  margin-top: calc(var(--gutter) * 1.5);
}
.MentoringPage_pairing-item__self-driven__-kl8k {
  background: var(--color-surface-darker);
  border-radius: var(--radius-default);
  padding: 0.25rem 0.5rem;
  font-style: italic;
  color: var(--color-text-subtle);
}
.MentoringPage_pairing-item__expert-selection__y5V-q {
  width: 100%;
}

.MentoringPage_expert-select__ujvEt {
  width: 100%;
}
.MentoringPage_expert-select__ujvEt .selectContainer {
  width: 100%;
}
.MentoringPage_expert-select__ujvEt .select {
  min-height: 2.5rem;
  font-size: var(--font-size-base);
}`, "",{"version":3,"sources":["webpack://./src/views/MentoringPage.module.scss"],"names":[],"mappings":"AACE;EACE,sCAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,sCAAA;EACA,4CAAA;EACA,wBAAA;EACA,UAAA;AADJ;;AAMA;EACE,yBAAA;EACA,sBAAA;AAHF;;AAOA;EACE,mBAAA;AAJF;AAME;EACE,kCAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAJJ;AAOE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AALJ;AAQE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AANJ;;AAWA;EACE,qBAAA;AARF;AAUE;EACE,kCAAA;EACA,gBAAA;EACA,sBAAA;EACA,+BAAA;AARJ;;AAaA;EACE,kBAAA;EACA,aAAA;EACA,+BAAA;EACA,kBAAA;AAVF;;AAaA,gCAAA;AACA;EACE,aAAA;EACA,4DAAA;EACA,YAAA;AAVF;;AAaA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,sCAAA;EACA,oCAAA;EACA,sBAAA;EACA,qCAAA;AAVF;AAYE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAVJ;AAaE;EACE,gBAAA;EACA,kCAAA;AAXJ;AAcE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,4BAAA;AAZJ;AAeE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;AAbJ;AAgBE;EACE,mCAAA;EACA,+BAAA;EACA,sBAAA;AAdJ;AAiBE;EACE,+BAAA;EACA,kCAAA;EACA,qCAAA;AAfJ;AAkBE;EACE,uCAAA;EACA,oCAAA;EACA,uBAAA;EACA,kBAAA;EACA,+BAAA;AAhBJ;AAmBE;EACE,WAAA;AAjBJ;;AAsBA;EACE,WAAA;AAnBF;AAqBE;EACE,WAAA;AAnBJ;AAsBE;EACE,kBAAA;EACA,gCAAA;AApBJ","sourcesContent":[".mentoring {\n  &__container {\n    background: var(--color-surface-light);\n  }\n  \n  &__controls {\n    display: flex;\n    align-items: center;\n    gap: var(--gutter);\n    flex-wrap: wrap;\n    position: sticky;\n    top: var(--nav-height);\n    background: var(--color-surface-light);\n    border-bottom: 1px solid var(--color-border);\n    padding: 0 var(--gutter);\n    z-index: 2;\n  }\n}\n\n// Mentorship Container\n.content-container {\n  margin-top: var(--gutter);\n  padding: var(--gutter);\n}\n\n// Pairing Groups\n.pairing-group {\n  margin-bottom: 2rem;\n  \n  &__title {\n    font-size: var(--font-size-larger);\n    font-weight: 600;\n    margin-bottom: 1rem;\n    display: flex;\n    align-items: center;\n  }\n  \n  &__member {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n  }\n  \n  &__avatar {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    object-fit: cover;\n  }\n}\n\n// Skill Group within Pairing Groups\n.pairing-skill-group {\n  margin-bottom: 1.5rem;\n  \n  &__title {\n    font-size: var(--font-size-larger);\n    font-weight: 500;\n    margin-bottom: 0.75rem;\n    color: var(--color-text-subtle);\n  }\n}\n\n// No Pairings Message\n.no-pairings {\n  text-align: center;\n  padding: 2rem;\n  color: var(--color-text-subtle);\n  font-style: italic;\n}\n\n/* Mentorship Pairings Section */\n.pairings-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));\n  gap: 1.25rem;\n}\n\n.pairing-item {\n  display: flex;\n  flex-direction: column;\n  gap: var(--gutter);\n  background: var(--color-surface-light);\n  border-radius: var(--radius-default);\n  padding: var(--gutter);\n  border: 1px solid var(--color-border);\n  \n  &__skill {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  \n  &__skill-title {\n    font-weight: 600;\n    font-size: var(--font-size-larger);\n  }\n  \n  &__members {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: calc(var(--gutter) / 2);\n  }\n  \n  &__focus, &__expert {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: calc(var(--gutter) / 8);\n  }\n  \n  &__label {\n    font-size: var(--font-size-smaller);\n    color: var(--color-text-subtle);\n    margin-bottom: 0.25rem;\n  }\n  \n  &__arrow {\n    color: var(--color-text-subtle);\n    padding: 0 calc(var(--gutter) / 2);\n    margin-top: calc(var(--gutter) * 1.5);\n  }\n\n  &__self-driven {\n    background: var(--color-surface-darker);\n    border-radius: var(--radius-default);\n    padding: 0.25rem 0.5rem;\n    font-style: italic;\n    color: var(--color-text-subtle);\n  }\n  \n  &__expert-selection {\n    width: 100%;\n  }\n}\n\n// Expert selection dropdown\n.expert-select {\n  width: 100%;\n  \n  :global(.selectContainer) {\n    width: 100%;\n  }\n  \n  :global(.select) {\n    min-height: 2.5rem;\n    font-size: var(--font-size-base);\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mentoring__container": `MentoringPage_mentoring__container__zwyfd`,
	"mentoring__controls": `MentoringPage_mentoring__controls__yDCfN`,
	"content-container": `MentoringPage_content-container__1gu9K`,
	"pairing-group": `MentoringPage_pairing-group__MruTd`,
	"pairing-group__title": `MentoringPage_pairing-group__title__QY5Fo`,
	"pairing-group__member": `MentoringPage_pairing-group__member__8jUPk`,
	"pairing-group__avatar": `MentoringPage_pairing-group__avatar__dzuw0`,
	"pairing-skill-group": `MentoringPage_pairing-skill-group__vwpXh`,
	"pairing-skill-group__title": `MentoringPage_pairing-skill-group__title__DcItv`,
	"no-pairings": `MentoringPage_no-pairings__NZOzQ`,
	"pairings-list": `MentoringPage_pairings-list__1JiIh`,
	"pairing-item": `MentoringPage_pairing-item__yraG8`,
	"pairing-item__skill": `MentoringPage_pairing-item__skill__+koU0`,
	"pairing-item__skill-title": `MentoringPage_pairing-item__skill-title__LyL4d`,
	"pairing-item__members": `MentoringPage_pairing-item__members__JmPQq`,
	"pairing-item__focus": `MentoringPage_pairing-item__focus__nU5Uz`,
	"pairing-item__expert": `MentoringPage_pairing-item__expert__R-BZC`,
	"pairing-item__label": `MentoringPage_pairing-item__label__Kee+h`,
	"pairing-item__arrow": `MentoringPage_pairing-item__arrow__twsSr`,
	"pairing-item__self-driven": `MentoringPage_pairing-item__self-driven__-kl8k`,
	"pairing-item__expert-selection": `MentoringPage_pairing-item__expert-selection__y5V-q`,
	"expert-select": `MentoringPage_expert-select__ujvEt`
};
export default ___CSS_LOADER_EXPORT___;
